import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/constants";
import { Quote } from "lucide-react";

export default function Reviews() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/testimonials`).then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <section data-testid="reviews-section" className="bg-[#FFF9E6] border-t border-[#1A243B]/10">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <p className="text-sm font-bold tracking-widest uppercase text-[#2D3748]/70 mb-3">What families are saying</p>
        <h2 className="text-3xl md:text-4xl text-[#1A243B] mb-4">Testimonials</h2>
        <p className="text-base md:text-lg text-[#2D3748] leading-relaxed max-w-2xl mb-12">
          Real reviews from homeschool families who've worked with Ready and Right Testing Services for testing and homeschool support services in Oregon and Washington.
        </p>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <figure key={i} data-testid={`review-card-${i}`} className="bg-white rounded-3xl p-8 shadow-sm flex flex-col">
              <span className="w-10 h-10 rounded-full bg-[#FFC107] flex items-center justify-center mb-5">
                <Quote className="w-4 h-4 text-[#1A243B]" />
              </span>
              <blockquote className="font-display italic text-lg text-[#1A243B] leading-relaxed flex-1">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-5 text-sm font-bold text-[#2D3748]">— {t.name}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
